// extracted by mini-css-extract-plugin
module.exports = {"container":"product-details-section_container__sNJY3","title":"product-details-section_title__kvsRN"};